import React, { useState } from 'react';
import classNames from 'classnames';

interface ListProps<T> {
  items: T[];
  renderItem: (item: T, key: number) => React.ReactChild;
  heading?: string | React.ReactChild;
  useDefaultLayout?: boolean;
  itemsClamp?: number;
  showMoreLabel?: string;
  className?: string;
  listClassName?: string;
}

export const List = <T extends {}>(props: ListProps<T>) => {
  const {
    items,
    heading,
    renderItem,
    className,
    listClassName,
    itemsClamp,
    useDefaultLayout = true,
    showMoreLabel = 'Show more'
  } = props;

  const [showAllItems, setShowAllItems] = useState(false);

  const itemsList = itemsClamp && !showAllItems
    ? items.slice(0, itemsClamp)
    : items;

  return (
    <div className={classNames('insuranceList', className, {
      "insuranceList--defaultLayout": useDefaultLayout,
    })}>
      {heading && (
        <div className='insuranceList__heading'>
          {heading}
        </div>
      )}
      {itemsList && itemsList.length > 0 && (
        <ul className={classNames('insuranceList__items', listClassName)}>
          {itemsList.map(renderItem)}
          {!showAllItems && itemsClamp && items.length > itemsClamp && (
            <li>
              <button className='insuranceList__showMore' onClick={() => setShowAllItems(true)}>
                {`${showMoreLabel} + ${items.length - itemsClamp}`}
              </button>
            </li>
          )}
        </ul>
      )}
    </div>
  )
};
